import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import imgHeaderBg from '../../img/block-1-bg.png';
import imgBlock21 from '../../img/block-2-item-1.jpg';
import imgBlock22 from '../../img/block-2-item-2.jpg';
import imgBlock23 from '../../img/block-2-item-3.jpg';
import imgBlock24 from '../../img/block-2-item-4.jpg';
import imgBlock25 from '../../img/block-2-item-5.jpg';
import imgBlock26 from '../../img/block-2-item-6.jpg';
import imgBlock31 from '../../img/block-3-item-1.jpg';
import imgBlock32 from '../../img/block-3-item-2.jpg';
// translate
import messages from './messages';

function IndexPage(props) {
  const { intl, isAuthenticated } = props;
  return (
    <div>
      <div
        className="container-fluid block-1"
        style={{ backgroundImage: `url('${imgHeaderBg}')` }}
      >
        <div className="row">
          <div className="container">
            <div className="row">
              <p className="text-header">
                <FormattedHTMLMessage {...messages.header} />
              </p>
              <p className="text">
                {intl.formatMessage(messages.text)}
              </p>

              {isAuthenticated &&
                <p className="text">
                  <Link className="button trans" to="/dashboard">
                    {intl.formatMessage(messages.dashboard)}
                  </Link>
                </p>}

              {!isAuthenticated &&
                <p className="text">
                  <Link className="button trans" to="#signup">
                    {intl.formatMessage(messages.register)}
                  </Link>
                </p>}
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid block-2">
        <div className="row">
          <div className="container">
            <div className="row">
              <p className="text-header">
                {intl.formatMessage(messages.partnerTitle)}
              </p>

              <p className="text underheader-text">
                {intl.formatMessage(messages.partnerText)}
              </p>

              <div className="col-md-4 block-2-item-wrap">
                <div className="block-2-item">
                  <img src={imgBlock21} alt="" className="block-2-img" />
                  <p className="text">
                    {intl.formatMessage(messages.partnerText2)}
                  </p>
                </div>
              </div>

              <div className="col-md-4 block-2-item-wrap">
                <div className="block-2-item">
                  <img src={imgBlock22} alt="" className="block-2-img" />
                  <p className="text">
                    {intl.formatMessage(messages.partnerText3)}
                  </p>
                </div>
              </div>

              <div className="col-md-4 block-2-item-wrap">
                <div className="block-2-item">
                  <img src={imgBlock23} alt="" className="block-2-img" />
                  <p className="text">
                    {intl.formatMessage(messages.partnerText4)}
                  </p>
                </div>
              </div>

              <div className="col-md-4 block-2-item-wrap">
                <div className="block-2-item">
                  <img src={imgBlock24} alt="" className="block-2-img" />
                  <p className="text">
                    {intl.formatMessage(messages.partnerText5)}
                  </p>
                </div>
              </div>

              <div className="col-md-4 block-2-item-wrap">
                <div className="block-2-item">
                  <img src={imgBlock25} alt="" className="block-2-img" />
                  <p className="text">
                    {intl.formatMessage(messages.partnerText6)}
                  </p>
                </div>
              </div>

              <div className="col-md-4 block-2-item-wrap">
                <div className="block-2-item">
                  <img src={imgBlock26} alt="" className="block-2-img" />
                  <p className="text">
                    {intl.formatMessage(messages.partnerText7)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid block-3">
        <div className="row">
          <div className="container">
            <div className="row">
              <p className="text-header">
                {intl.formatMessage(messages.partnerBenefitTitle)}
              </p>

              <p className="text underheader-text">
                <FormattedHTMLMessage {...messages.partnerBenefitText} />
              </p>

              <div className="col-md-6 block-2-item-wrap">
                <div className="block-2-item">
                  <img src={imgBlock31} alt="" className="block-2-img" />

                  <p className="text">
                    {intl.formatMessage(messages.partnerBenefitText2)}
                  </p>
                </div>
              </div>

              <div className="col-md-6 block-2-item-wrap">
                <div className="block-2-item">
                  <img src={imgBlock32} alt="" className="block-2-img" />

                  <p className="text">
                    {intl.formatMessage(messages.partnerBenefitTex3)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

IndexPage.propTypes = {
  intl: intlShape.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isAuthenticated: state.get('auth').isAuthenticated,
  };
}

export default connect(mapStateToProps)(injectIntl(IndexPage));



// WEBPACK FOOTER //
// ./src/pages/IndexPage/index.js